
{
  "familyId": "GET-BREUK-BASIS",
  "questions": [
    {
      "id": "GET-BREUK-BASIS-001",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk zie je hier?",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{1}{4}$", "$\\frac{4}{3}$", "$\\frac{3}{1}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [{ "numerator": 3, "denominator": 4 }],
            "label": "3 van de 4 delen gekleurd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{3}{4}$: 3 van 4 stukken",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk aflezen van een plaatje",
            "content": "Tel het totaal aantal gelijke stukken → dat getal komt onder de streep. Tel de gekleurde stukken → dat getal komt boven de streep. Hier: 4 stukken totaal, 3 gekleurd = $\\frac{3}{4}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_read_bar",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Je ziet 4 gelijke stukken. Daarvan zijn er 3 gekleurd. Het getal boven de streep zegt hoeveel stukken gekleurd zijn: 3. Het getal onder de streep zegt hoeveel stukken er totaal zijn: 4. Samen vormt dat $\\frac{3}{4}$. Controleer: 3 gekleurd van 4 totaal — klopt.",
        "solutionSteps": [
          "Tel het totaal aantal stukken: 4 → onder de streep",
          "Tel de gekleurde stukken: 3 → boven de streep",
          "Schrijf de breuk: $\\frac{3}{4}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 van de 4 stukken zijn gekleurd: $\\frac{3}{4}$.",
          "1": "Bij $\\frac{1}{4}$ zou maar 1 stuk gekleurd zijn. Tel opnieuw: er zijn 3 stukken gekleurd, niet 1.",
          "2": "Bij $\\frac{4}{3}$ staat het totaal boven de streep. Maar het getal boven telt de gekleurde stukken, het getal onder het totaal. Hier dus: 3 boven, 4 onder.",
          "3": "$\\frac{3}{1}$ betekent 3 hele. Dat past niet bij het plaatje — je hebt minder dan 1 heel."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-count-error", "label": "Verkeerd aantal geteld", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Boven en onder verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-whole-confusion", "label": "Breuk als geheel getal gelezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-002",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "grid_shade",
      "question": "Kleur $\\frac{3}{8}$ van het rooster in.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 4,
          "targetCount": 3,
          "mode": "shade_fraction",
          "showCounter": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fractionStrip",
          "showWhen": "wrong",
          "data": {
            "fractions": [{ "numerator": 3, "denominator": 8 }],
            "label": "3 van de 8 vakjes"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk inkleuren",
            "content": "Het getal onder de streep (8) zegt hoeveel vakjes er totaal zijn. Het getal boven de streep (3) zegt hoeveel je moet inkleuren. Tel 8 vakjes in het rooster en kleur er 3 in.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_shade_grid",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 4 = 8 vakjes. De breuk $\\frac{3}{8}$ zegt: kleur 3 van de 8 vakjes in. Het getal onder de streep vertelt het totaal, het getal boven hoeveel je inkleurt.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 2 × 4 = 8",
          "Het getal boven de streep is 3 → kleur 3 vakjes in",
          "Check: 3 van de 8 vakjes = $\\frac{3}{8}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "GET-BREUK-BASIS-003",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij dit plaatje?",
      "context": null,
      "options": ["$\\frac{2}{5}$", "$\\frac{3}{5}$", "$\\frac{5}{2}$", "$\\frac{2}{3}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [{ "numerator": 2, "denominator": 5 }],
            "label": "2 van de 5 punten op"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "$\\frac{2}{5}$: 2 van 5 stukken op",
            "visualType": "circle",
            "showEaten": true
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk aflezen van een cirkel",
            "content": "Tel het totaal aantal gelijke stukken → onder de streep. Tel de opgegeten stukken → boven de streep. Hier: 5 stukken totaal, 2 op = $\\frac{2}{5}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_read_circle",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De taart is verdeeld in 5 gelijke stukken. Daarvan zijn er 2 op (gekleurd). Boven de streep = 2 (opgegeten), onder de streep = 5 (totaal). Samen: $\\frac{2}{5}$. Stappen: eerst totaal tellen, daarna gekleurd tellen, dan de breuk opschrijven.",
        "solutionSteps": [
          "Tel het totaal aantal stukken: 5 → onder de streep",
          "Tel de opgegeten stukken: 2 → boven de streep",
          "Schrijf de breuk: $\\frac{2}{5}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 van de 5 stukken zijn op: $\\frac{2}{5}$.",
          "1": "$\\frac{3}{5}$ zou kloppen als je de overgebleven stukken telt. Maar de vraag gaat over de opgegeten stukken: 2.",
          "2": "Bij $\\frac{5}{2}$ staan boven en onder omgedraaid. Het totaal (5) hoort onder de streep, het gekleurde aantal (2) boven.",
          "3": "$\\frac{2}{3}$ klopt niet — er zijn 5 stukken totaal, niet 3."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-remaining-vs-eaten", "label": "Overgebleven i.p.v. opgegeten geteld", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Boven en onder verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-wrong-total", "label": "Verkeerd totaal geteld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-004",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "fraction_equivalence_match",
      "question": "Welk plaatje hoort bij de breuk $\\frac{1}{3}$?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "fractionEquivalenceMatch": {
          "targetNumerator": 1,
          "targetDenominator": 3,
          "candidates": [
            { "numerator": 1, "denominator": 3, "isMatch": true },
            { "numerator": 2, "denominator": 3, "isMatch": false },
            { "numerator": 1, "denominator": 4, "isMatch": false },
            { "numerator": 1, "denominator": 2, "isMatch": false }
          ]
        }
      },
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [{ "numerator": 1, "denominator": 3 }],
            "label": "Zoek het plaatje voor $\\frac{1}{3}$"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van breuk naar plaatje",
            "content": "Lees de breuk: $\\frac{1}{3}$ betekent 1 deel van 3 gelijke stukken. Zoek het plaatje met 3 stukken waarvan er 1 gekleurd is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_match",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "$\\frac{1}{3}$ betekent: verdeel in 3 gelijke stukken en kleur er 1. Het juiste plaatje toont precies dat: 3 stukken, 1 gekleurd. De andere plaatjes hebben óf een ander totaal (4 of 2 stukken) óf het verkeerde aantal gekleurd.",
        "solutionSteps": [
          "Lees het getal onder de streep: 3 → zoek een plaatje met 3 stukken",
          "Lees het getal boven de streep: 1 → er moet 1 stuk gekleurd zijn",
          "Plaatje met 3 stukken en 1 gekleurd = $\\frac{1}{3}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "GET-BREUK-BASIS-005",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "grid_shade",
      "question": "Kleur $\\frac{5}{6}$ van het rooster in.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 3,
          "targetCount": 5,
          "mode": "shade_fraction",
          "showCounter": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fractionStrip",
          "showWhen": "wrong",
          "data": {
            "fractions": [{ "numerator": 5, "denominator": 6 }],
            "label": "5 van de 6 vakjes"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk inkleuren — bijna alles!",
            "content": "Het getal onder de streep (6) zegt hoeveel vakjes er totaal zijn. Het getal boven de streep (5) zegt hoeveel je inkleurt. Bijna alles! Alleen 1 vakje blijft leeg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_shade_grid_large_teller",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 3 = 6 vakjes. De breuk $\\frac{5}{6}$ zegt: kleur 5 van de 6 vakjes in. Er blijft maar 1 vakje leeg. Controle: 5 gekleurd + 1 leeg = 6 totaal — klopt.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 2 × 3 = 6",
          "Het getal boven de streep is 5 → kleur 5 vakjes in",
          "Check: 5 van de 6 vakjes = $\\frac{5}{6}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "GET-BREUK-BASIS-006",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Een chocoladereep is verdeeld in 8 gelijke stukken. Jij eet er 3 op. Welke breuk heb je opgegeten?",
      "context": null,
      "options": ["$\\frac{3}{8}$", "$\\frac{5}{8}$", "$\\frac{8}{3}$", "$\\frac{3}{5}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [{ "numerator": 3, "denominator": 8 }],
            "label": "3 van de 8 stukken opgegeten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 8,
            "label": "$\\frac{3}{8}$: 3 van 8 stukken op",
            "visualType": "bar",
            "showEaten": true
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk bij een verhaaltje",
            "content": "De reep heeft 8 stukken (onder de streep = 8). Je eet er 3 op (boven de streep = 3). De breuk is $\\frac{3}{8}$. Let op: de vraag gaat over wat je hebt opgegeten, niet wat er over is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_context",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De reep heeft 8 gelijke stukken. Je eet er 3 op. Boven de streep komt 3 (opgegeten), onder de streep 8 (totaal). De breuk is $\\frac{3}{8}$. Stappen: eerst het totaal vaststellen, dan het opgegeten deel, dan de breuk schrijven.",
        "solutionSteps": [
          "Totaal aantal stukken: 8 → onder de streep",
          "Opgegeten stukken: 3 → boven de streep",
          "Breuk: $\\frac{3}{8}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 opgegeten van 8 totaal = $\\frac{3}{8}$.",
          "1": "$\\frac{5}{8}$ is het deel dat over is (8 − 3 = 5). De vraag gaat over wat je hebt opgegeten, dus $\\frac{3}{8}$.",
          "2": "Bij $\\frac{8}{3}$ staan boven en onder omgedraaid. Het totaal (8) hoort onder de streep, het opgegeten aantal (3) boven.",
          "3": "$\\frac{3}{5}$ klopt niet — er zijn 8 stukken totaal, niet 5. De 5 is het aantal dat over is."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-remaining-vs-eaten", "label": "Rest i.p.v. opgegeten deel", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Boven en onder verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-wrong-total", "label": "Rest als totaal gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-007",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk zie je hier?",
      "context": null,
      "options": ["$\\frac{4}{6}$", "$\\frac{2}{6}$", "$\\frac{6}{4}$", "$\\frac{4}{2}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [{ "numerator": 4, "denominator": 6 }],
            "label": "4 van de 6 punten gekleurd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 6,
            "label": "$\\frac{4}{6}$: 4 van 6 stukken",
            "visualType": "circle",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk aflezen van een cirkel",
            "content": "Tel het totaal aantal stukken (onder de streep) en de gekleurde stukken (boven de streep). Hier: 6 stukken totaal, 4 gekleurd = $\\frac{4}{6}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_read_circle_sixths",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De cirkel is verdeeld in 6 gelijke stukken. Daarvan zijn er 4 gekleurd. Boven de streep = 4, onder de streep = 6. De breuk is $\\frac{4}{6}$ (gelijk aan $\\frac{2}{3}$). Stappen: tel het totaal, tel het gekleurde deel, schrijf de breuk.",
        "solutionSteps": [
          "Tel het totaal aantal stukken: 6 → onder de streep",
          "Tel de gekleurde stukken: 4 → boven de streep",
          "Schrijf de breuk: $\\frac{4}{6}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 van de 6 stukken zijn gekleurd: $\\frac{4}{6}$.",
          "1": "$\\frac{2}{6}$ zou kloppen als er maar 2 gekleurd waren. Tel opnieuw: er zijn 4 gekleurd, niet 2.",
          "2": "Bij $\\frac{6}{4}$ staan boven en onder omgedraaid. Het totaal (6) hoort onder de streep, het gekleurde aantal (4) boven.",
          "3": "$\\frac{4}{2}$ betekent meer dan 2 hele. Dat past niet bij het plaatje — je hebt minder dan 1 heel."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-count-error", "label": "Verkeerd aantal geteld", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Boven en onder verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-whole-confusion", "label": "Breuk als geheel getal", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-008",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Een reep is in 10 gelijke stukken verdeeld. Er zijn 7 stukken opgegeten. Welke breuk is nog over?",
      "context": null,
      "options": ["$\\frac{3}{10}$", "$\\frac{7}{10}$", "$\\frac{10}{3}$", "$\\frac{3}{7}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [{ "numerator": 7, "denominator": 10 }],
            "label": "7 van de 10 opgegeten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 10,
            "label": "$\\frac{3}{10}$: 3 van 10 over",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rest van een breuk",
            "content": "Totaal = $\\frac{10}{10}$ (1 hele). Opgegeten = $\\frac{7}{10}$. Over = $\\frac{10}{10}$ − $\\frac{7}{10}$ = $\\frac{3}{10}$. Of: 10 − 7 = 3 stukken over van 10.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_remainder_context",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er zijn 10 stukken totaal. 7 zijn opgegeten, dus 10 − 7 = 3 stukken over. De breuk die nog over is = $\\frac{3}{10}$. Controle via breuken: $\\frac{10}{10}$ − $\\frac{7}{10}$ = $\\frac{3}{10}$ ✓.",
        "solutionSteps": [
          "Totaal aantal stukken: 10",
          "Opgegeten: 7 → over: 10 − 7 = 3",
          "Breuk over: $\\frac{3}{10}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 10 − 7 = 3 stukken over, dus $\\frac{3}{10}$.",
          "1": "$\\frac{7}{10}$ is het deel dat opgegeten is, niet wat over is. Lees de vraag goed: hoeveel is nog over?",
          "2": "Bij $\\frac{10}{3}$ staan boven en onder omgedraaid. Het totaal (10) hoort onder de streep.",
          "3": "$\\frac{3}{7}$ klopt niet — er zijn 10 stukken totaal, niet 7. De 7 is het aantal dat op is."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.fraction-remaining-vs-eaten", "label": "Opgegeten i.p.v. rest geteld", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Boven en onder verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-wrong-total", "label": "Rest als totaal gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-FSB-001",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "fraction_strip_builder",
      "question": "Bouw $\\frac{3}{4}$ op de strook: verdeel in 4 gelijke stukken en kleur er 3 in.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "fractionStripBuilder": {
          "targetDenominator": 4,
          "targetNumerator": 3,
          "mode": "both"
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fractionStrip",
          "showWhen": "wrong",
          "data": {
            "fractions": [{ "numerator": 3, "denominator": 4 }],
            "label": "$\\frac{3}{4}$: 3 van 4 stukken"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk bouwen",
            "content": "Het getal onder de streep zegt in hoeveel gelijke stukken je de strook moet verdelen. Het getal boven de streep zegt hoeveel stukken je inkleurt. Bij $\\frac{3}{4}$: 4 stukken, 3 gekleurd.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_strip_build_kwart",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      },
      "feedback": {
        "explanationText": "Bij $\\frac{3}{4}$ is het getal onder de streep 4 → verdeel de strook in 4 gelijke stukken. Het getal boven de streep is 3 → kleur 3 van die stukken in. Je ziet nu drie kwart van de hele strook. Stappen: eerst verdelen, dan inkleuren, dan controleren dat er 3 van 4 zichtbaar zijn.",
        "solutionSteps": [
          "Lees het getal onder de streep: 4 → verdeel in 4 stukken",
          "Lees het getal boven de streep: 3 → kleur 3 stukken in",
          "Resultaat: $\\frac{3}{4}$ ✓"
        ]
      }
    }
  ]
}
